import { API_ENDPOINTS, getApiUrl } from "../config";
import { buildBffRequestHeaders } from "./bffRequestHeaders";

/**
 * Search for address suggestions using Amazon Location Service
 * @param text - The search query text (minimum 2 characters)
 * @returns Promise with array of suggestion results
 */
export const searchLocationSuggestions = async (text: string): Promise<any[]> => {
    if (!text || text.trim().length < 2) {
        return [];
    }

    const url = getApiUrl(API_ENDPOINTS.LOCATION_SUGGESTIONS);
    
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: buildBffRequestHeaders(),
            body: JSON.stringify({ text: text.trim() }),
        });
        
        if (!response.ok) {
            const errorText = await response.text();
            console.error('Location suggestions API error:', response.status, errorText);
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        return Array.isArray(data) ? data : [];
    } catch (error) {
        console.error('Error searching location suggestions:', error);
        throw error;
    }
};

/**
 * Get full place details by PlaceId
 * @param placeId - The PlaceId from Amazon Location Service
 * @returns Promise with place details
 */
export const getPlaceDetails = async (placeId: string): Promise<any> => {
    if (!placeId) {
        throw new Error("PlaceId is required");
    }

    const url = getApiUrl(`${API_ENDPOINTS.LOCATION_PLACES}/${placeId}`);
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: buildBffRequestHeaders(),
        });
        
        if (!response.ok) {
            const errorText = await response.text();
            console.error('Get place details API error:', response.status, errorText);
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error getting place details:', error);
        throw error;
    }
};

